export interface Hyperlink {
    text: string;
    url: string;
}

export function toLinkHref(url: string): string {
    if (!url) {
        return url;
    }

    return /^https?:\/\//i.test(url) ? url : `https://${url}`;
}